<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="chara.world" />
    <!-- Main Content-->
    <main>
        <el-row justify="center">
            <el-col :span="12">
                <div id="page-selector" class="page-selector row py-4 py-lg-5 justify-content-center">
                    <div class="page-tab col" id="profile">
                        <router-link :to="'/chara/' + title + '/profile'">简介</router-link>
                    </div>
                    <div class="page-tab col" id="story">
                        <router-link :to="'/chara/' + title + '/story'">故事</router-link>
                    </div>
                    <div class="page-tab col" id="closet">
                        <router-link :to="'/chara/' + title + '/closet'">衣柜</router-link>
                    </div>
                    <div class="page-tab col" id="gallery">
                        <router-link :to="'/chara/' + title + '/gallery'">图库</router-link>
                    </div>
                </div>
                <!-- <router-view :chara="chara" :closet="closet" :gallery="gallery" :charas="charas" :articles="articles"
                    :title="title" /> -->
                <router-view />
            </el-col>
        </el-row>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'

let route = useRoute()
const title = route.params.name[0]
let router = useRouter()
const current_page_name = router.currentRoute.value.name
const chara = ref([{ world: '' }])
const closet = ref()
const gallery = ref()
const charas = ref()
const articles = ref()
const closets = ref()
watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)

const getData = (name) => {
    const params = {
        name: name
    };
    service.get("/user/closet/listCloset", { params })
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                rst.sort((a, b) => a.sort - b.sort);
                const gallery = rst.map(item => item.image);

                const closetInfo = {};
                rst.forEach(item => {
                    const name = item.age + item.name;
                    if (!closetInfo[name]) {
                        closetInfo[name] = [];
                    }
                    closetInfo[name].push(item);
                });
                closet.value = { closetInfo: closetInfo, gallery: gallery };
            } else {
                console.error('返回服设信息为空', error);
            }
        }).catch(error => {
            console.error('获取服设信息失败', error);
        });
    // var api = '/chara.php?name=' + title
    // axios
    //     .get(api)
    //     .then(res => {
    //         chara.value = res.data[0]
    //         for (let [k, v] of Object.entries(chara.value)) {
    //             chara.value[k] = escape2Html(v)
    //         }
    //         charas.value = res.data[1]
    //         articles.value = res.data[2]
    //         closets.value = res.data[3]
    //         let cl = []
    //         let cl_t = []
    //         let c = Object.values(require.context('img', true, /^.\/closet_/).keys())
    //         let g = Object.values(require.context('img', true, /^.\/gallery_/).keys())
    //         let n_list = []
    //         let allCloset = []
    //         let allCloset_t = []
    //         let ga_list = []
    //         let ga_list_t = []
    //         for (let clo of closets.value) {
    //             const n = clo.name + '-' + clo.age + '-' + clo.clothes
    //             n_list.push(n)
    //         }
    //         n_list = [...new Set(n_list)]
    //         for (let nl of n_list) {
    //             let clos = []
    //             for (let clo of closets.value) {
    //                 const n = clo.name + '-' + clo.age + '-' + clo.clothes
    //                 let n_diff = ''
    //                 if (clo.diff != '') {
    //                     n_diff = n + '-' + clo.diff
    //                 } else {
    //                     n_diff = n
    //                 }

    //                 if (n == nl) {
    //                     for (let i of c) {
    //                         if (i.includes(n_diff)) {
    //                             let q = i.replace(/^.\//, '')
    //                             clo.link = require(`img/${q}`)
    //                             clo.link_t = require(`img/thumbnail/${q}`)
    //                         }
    //                     }
    //                     clos.push(clo)
    //                     allCloset.push(clo.link)
    //                 }
    //             }
    //             cl.push(clos)
    //         }
    //         for (let clos of cl) {
    //             ga_list = []
    //             ga_list_t = []
    //             const na = clos[0].code + '-' + clos[0].name
    //             for (let j of g) {
    //                 if (j.includes(na)) {
    //                     let q = j.replace(/^.\//, '')
    //                     ga_list.push(require(`img/${q}`))
    //                     ga_list_t.push(require(`img/thumbnail/${q}`))
    //                 }
    //             }
    //             clos[0].gallery = ga_list
    //             clos[0].gallery_t = ga_list_t
    //         }
    //         let ga = []
    //         let ga_t = []
    //         for (let j of g) {
    //             if (j.includes(title) && !j.includes('-g')) {
    //                 let q = j.replace(/^.\//, '')
    //                 ga.push(require(`img/${q}`))
    //                 ga_t.push(require(`img/thumbnail/${q}`))
    //             }
    //         }
    //         closet.value = [cl, allCloset]
    //         gallery.value = [ga.reverse(), ga_t.reverse()]
    //     })
    //     .catch(err => {
    //         console.log(err)
    //     })
}

onMounted(() => {
    var current_page = '#' + current_page_name
    $(current_page).removeClass('page-tab')
    $(current_page).addClass('page-tab-selected')
    // $('#' + current_page).addClass('page-tab-selected')
    // getData(title)
})

function show(prefix, content) {
    if (content) {
        if (!content.includes(prefix) && prefix != 'null') {
            return prefix + content
        } else {
            return content
        }
    }
}

function escape2Html(str) {                            //转义字符转换普通字符的方法
    var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'middot': '·' };
    return str.replace(/&(lt|gt|nbsp|amp|quot|middot);/ig, function (all, t) { return arrEntities[t]; });
}


function keyword(str, charas, articles, name) {
    str = keyword_search(str, charas, name)
    str = keyword_search(str, articles, '')
    return str
}

function keyword_search(str, keywords, name) {
    if (str) {
        for (let j = 0; j < keywords.length; j++) {
            const keyword = keywords[j]
            const i = str.indexOf(keyword)
            const str_list = str.split(keyword)
            let str_res = ''
            if (i && keyword !== name && name !== '') {
                for (let k = 0; k < str_list.length - 1; k++) {
                    str_res += str_list[k] + '<a href="/chara/' + keyword + '/profile">' + keyword + '</a>'
                }
                str_res += str_list[str_list.length - 1]
                str = str_res
            } else if (i && name == '') {
                for (let k = 0; k < str_list.length - 1; k++) {
                    str_res += str_list[k] + '<a href="/article/' + keyword + '">' + keyword + '</a>'
                }
                str_res += str_list[str_list.length - 1]
                str = str_res
            }
        }
    }
    return str
}
</script>
<style scoped>
.page-tab {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: skyblue;
    text-align: center;
    margin-right: 4px;
}

.page-tab a {
    color: white;
}

.page-tab:hover {
    background-color: rgba(135, 206, 235, 0.2);
}

.page-tab:hover a {
    color: skyblue;
}

.page-tab-selected {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: MediumTurquoise;
    text-align: center;
    margin-right: 4px;
}

.page-tab-selected a {
    color: white;
}

.info {
    background-color: white;
    padding: 2%;
}
</style>
